<template>
    <!-- 上传图片
         @author: 王汝鹏
         @date: 2019-9-16
    -->
  <index-form-item :labelText="labelName"
                   :labelWidth="labelWidth"
                   :labelPosition="labelPosition"
                   :textAlign="labelTextPosition"
                   :formType="formType"
                   :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-upload :action="uploadHost"
                 :limit="uploadLimit"
                 accept="image/jpeg, image/gif, image/png"
                 list-type="picture-card">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
  </index-form-item>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixFormItemTemplateChild 表单项子级混入
 */
import { mixFormItemTemplateChild } from "@/mixins/form_item/mix_form_item_template_child.js";


export default {
  mixins: [ mixFormItemTemplateChild ],
}

</script>


// WEBPACK FOOTER //
// src/components/form_item/FormItemUploadImage.vue